import { useRef } from 'react';

function imageKey(image) {
  if (image?.file_name && image?.ext) {
    return `${image.file_name}${image.ext}`;
  }
  return image?.url || null;
}

// Signed URLs change on every API response (X-Goog-Date). Keep the first ones seen
// for each hosted image so polling/refetch does not reload <img> elements.
export function useStableImageUrls(images = []) {
  const cacheRef = useRef(new Map());

  return images.map((image) => {
    const key = imageKey(image);
    if (!key || !image?.url) {
      return image;
    }

    const cached = cacheRef.current.get(key);
    if (cached) {
      return cached.url === image.url ? image : { ...image, ...cached };
    }

    cacheRef.current.set(key, { url: image.url, srcset: image.srcset });
    return image;
  });
}

export function useStableImage(image) {
  const images = useStableImageUrls(image ? [image] : []);
  return images[0];
}
